import { Navigate } from 'react-router-dom';

import { isOperatorShift } from '@/config/navigation';
import { selectUser, useAuthStore } from '@/features/auth/auth.store';

export function DefaultLandingPage() {
  const user = useAuthStore(selectUser);

  return <Navigate to={isOperatorShift(user?.groupIds) ? '/turno' : '/inicio'} replace />;
}
